import * as AF from "@/components/form-items/AbstractForm";
import { SupportedLocale } from "@/i18n";
import { useTranslation } from "react-i18next";

interface EShopFormProps {
  language: SupportedLocale;
}

export const EshopForm = ({ language }: EShopFormProps) => {
  const { t } = useTranslation();
  return (
    <AF.Col>
      <AF.Text
        name={`${language}.pageName`}
        label={t("cms.e-shop.form.pageName")}
        tootltip={t("cms.e-shop.form.pageName.tooltip")}
      />
    </AF.Col>
  );
};
